import { render, staticRenderFns } from "./AddressDocumentDetailed.vue?vue&type=template&id=ff295f36&"
import script from "./AddressDocumentDetailed.vue?vue&type=script&lang=js&"
export * from "./AddressDocumentDetailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports